export default defineNuxtRouteMiddleware(async (to) => {
  const { $i18n } = useNuxtApp()
  const language = useCookie('Augmento-locale', { domain: useCookiesDomain() })
  const localePath = useLocalePath()

  if (language.value && $i18n.locale.value !== language.value) {
    useSetLanguage(language.value, $i18n.locale)
    return navigateTo(localePath(to.fullPath as Parameters<typeof localePath>[0]), { replace: true })
  }
})
